package one.healthium.tasks.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class DailyTasksDto(
    @SerialName("days") val days: List<DayDto>,
    @SerialName("config") val config: Config,
)

@Serializable
internal data class DayDto(
    @SerialName("tasks") val tasks: List<DailyTaskInfoDto>
)
